export default "__VITE_ASSET__C$YMmBbQ__"